module.exports = __webpack_public_path__ + "media/img/Landing_Page/scholarship-02-b33dba9d78e7532fc6b58effdfcca8c4.jpg";